import { render, staticRenderFns } from "./UserPointsInApp.vue?vue&type=template&id=ac805fa6"
import script from "./UserPointsInApp.vue?vue&type=script&lang=js"
export * from "./UserPointsInApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports